import { GET_TAX_GROUP } from "../types";
  
  const initialState = { list: [], single: null };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_TAX_GROUP:
        return { ...state, list: payload };

      default:
        return state;
    }
  };
  
  export default reducer;
  